// src/theme/productionTheme.ts  
import type { Theme } from "./theme";

export const productionTheme: Theme = {
  // ===== Global =====
  background: "hsl(350 30% 98%)",
  headerBg: "linear-gradient(180deg, hsl(350 30% 98%) 0%, hsl(350 20% 94%) 100%)",
  headerTransparency: 0.6,
  fontH1: "hsl(350 70% 70%)",
  fontH2: "hsl(350 70% 70%)",
  fontH3: "hsl(350 70% 70%)",
  fontBody: "hsl(0 0% 10%)",

  // Headings & Subheadings (non-Hero)  ← the one that drives “Let’s create together…” if it’s outside Hero
  buttonBg: "hsl(350 70% 70%)",
  buttonText: "hsl(0 0% 100%)",
  buttonHoverBg: "hsl(350 70% 70% / 0.9)",

  // Tabs (factory values = Awards/Gallery tabs)
  tabActiveBg: "rgb(232 125 143)",     // active background
  tabActiveText: "rgb(255 255 255)",   // active text
  tabInactiveBg: "rgb(175 207 186)",   // inactive/hover background
  tabInactiveText: "rgb(26 26 26)",    // inactive/hover text

  // Awards Tabs (factory values)
  awardsTabActiveBg: "rgb(232 125 143)",     // active background
  awardsTabActiveText: "rgb(255 255 255)",   // active text
  awardsTabInactiveBg: "rgb(175 207 186)",   // inactive/hover background
  awardsTabInactiveText: "rgb(26 26 26)",    // inactive/hover text

  // ===== HERO (kept exactly as you had it) =====
  heroH1: "#ffffff",
  heroH2: "rgba(255,255,255,0.90)",          // keep white subtitle in Hero
  heroBtnBg: "#e6a4a4",
  heroBtnText: "#ffffff",
  heroBtnHoverBg: "#cc8f8f",
  heroBtnHoverText: "#f5f5f5",

  // ===== ABOUT =====
  aboutCardTint: "color-mix(in srgb, #e6a4a4 5%, transparent)",
  aboutBtnBg: "#e6a4a4",
  aboutBtnText: "#ffffff",
  aboutBtnHoverBg: "#cc8f8f",
  aboutBtnHoverText: "#f5f5f5",

  // ===== GALLERY (also drives sitewide <Button> via --primary) =====
  galleryTabBg: "#e6a4a4",
  galleryTabText: "#ffffff",
  galleryTabHoverBg: "#cc8f8f",
  galleryTabHoverText: "#f5f5f5",
  
  galleryCtaBg: "#e6a4a4",       // same as Hero/About buttons (editable per section)
  galleryCtaText: "#ffffff",
  galleryCtaHoverBg: "#cc8f8f",
  galleryCtaHoverText: "#f5f5f5",

};

/* --- NEW override support --- */
let runtimeOverride: Partial<Theme> | null = null;

export function setProductionOverride(t: Partial<Theme> | null) {
  runtimeOverride = t ? { ...t } : null;
}

export function resolveProductionTheme(): Theme {
  return runtimeOverride ? { ...productionTheme, ...runtimeOverride } : productionTheme;
}